import { Component, input } from '@angular/core';
import {
    WagtailPageContentElementInterface,
    WagtailPageContentRendererInterface
} from "@gea-waldviertler-website/gea-models";

@Component({
    selector: 'gea-shop-wagtail-elements',
    templateUrl: './wagtail-elements.component.html',
    standalone: false,
})
export class WagtailElementsComponent {
    public elements = input<WagtailPageContentElementInterface<WagtailPageContentRendererInterface>[] | null | undefined>(undefined)
}
